import defineRule from '../defineRule';
defineRule('alphanumeric', (value) => {
    if (typeof value !== 'string') {
        return false;
    }
    return /^[a-zA-Z0-9]*$/.test(value) || 'Must be alphanumeric.';
});
